import { parseAsArrayOf, parseAsString } from 'nuqs';

const arrayOfStrings = parseAsArrayOf(parseAsString);

export enum FoodFilterKey {
  Site = 'sites',
  Period = 'timePeriods',
  Customer = 'customers',
  ActivitiesImport = 'activitiesImport',
  Tag = 'tags',
  Created = 'created',
}

export enum FoodFilterColumn {
  Site = 'site',
  Period = 'period',
  Customer = 'customer',
  ActivitiesImport = 'activitiesImport',
  Tag = 'tag',
  RemoteId = 'remoteId',
  Created = 'created',
}

export enum FoodFilterApiKey {
  Site = 'sites',
  Period = 'time_periods',
  Customer = 'customers',
  ActivitiesImport = 'activity_imports',
  Tag = 'tags',
  Created = 'created',
}

export const foodFilters = {
  [FoodFilterKey.Site]: {
    column: FoodFilterColumn.Site,
    apiKey: FoodFilterApiKey.Site,
    type: arrayOfStrings,
  },
  [FoodFilterKey.Customer]: {
    column: FoodFilterColumn.Customer,
    apiKey: FoodFilterApiKey.Customer,
    type: arrayOfStrings,
  },
  [FoodFilterKey.Period]: {
    column: FoodFilterColumn.Period,
    apiKey: FoodFilterApiKey.Period,
    type: arrayOfStrings,
  },
  [FoodFilterKey.ActivitiesImport]: {
    column: FoodFilterColumn.ActivitiesImport,
    apiKey: FoodFilterApiKey.ActivitiesImport,
    type: arrayOfStrings,
  },
  [FoodFilterKey.Tag]: {
    column: FoodFilterColumn.Tag,
    apiKey: FoodFilterApiKey.Tag,
    type: arrayOfStrings,
  },
  [FoodFilterKey.Created]: {
    column: FoodFilterColumn.Created,
    apiKey: FoodFilterApiKey.Created,
    type: arrayOfStrings,
  },
};

export type FoodFilterOption = keyof typeof foodFilters;

export const foodFilterKeys = Object.keys(foodFilters) as FoodFilterOption[];
